module.exports = __webpack_public_path__ + "img/about_banner.9e06b985.png";